const AceOcnPermitToTransferKeys = {
    TITLE: "title",
    SCAC: "scac",
    VESSEL_NAME: "vesselName",
    VOYAGE_NUMBER: "voyageNumber",
    COUNTRY: "country",
    PORT_OF_DISCHARGE: "portOfDischarge",
    ETA: "eta",
    MODE_OF_TRANSPORT: "modeOfTransport",
    PAPERLESS_IN_BOND_PARTICIPANT: "paperlessInBondParticipant",
    ISSUER_SCAC: "issuerScac",
    SUBMITTED_DATE: "submittedDate",
    STATUS: "status",
    CREATED_DATE:"createdDate",
    RESPONSE_DATE:"responseDate",
    UPDATED_DATE:"updatedDate",
    CLOSE_BUTTON: "closeButton",  
    BillOfLading: {
      TITLE: "billOfLading.title",
      BILL_OF_LADING_NUMBER: "billOfLading.billOfLadingNumber",
      FIRMS_CODE: "billOfLading.firmsCode",
      BONDED_CARRIER_TYPE: "billOfLading.bondedCarrierType",
      BONDED_CARRIER: "billOfLading.bondedCarrier",
      CONTAINER_NUMBER: "billOfLading.containerNumber",
      QUANTITY: "billOfLading.quantity",
      REMARKS: "billOfLading.remarks"
    }
  }
  
  export default AceOcnPermitToTransferKeys
  